<template>
  <FlotoCrudContainer
    ref="list"
    as-table
    prepend-new-item
    :fetch-fn="getVmDetails"
    :columns="tableColumns"
  >
    <template v-slot:form> <span></span></template>
    <template v-slot:memoryLimit="{ item }">
      <td v-if="item.memoryLimit === -1" class="resource-link">
        {{ $tc('unlimited') }}
      </td>
      <td v-else class="resource-link">{{ item.memoryLimit }}</td>
    </template>
    <template v-slot:assetName="{ item }">
      <td>
        <a
          :href="
            $router.resolve(
              item['ci']
                ? $modules.getModuleRoute('cmdb', 'view', {
                    params: { id: item.id, ciType: $constants.CMDB },
                  })
                : $modules.getModuleRoute('asset', 'view', {
                    params: {
                      id: item.id,
                      assetType: $constants.ASSET_HARDWARE,
                    },
                  })
            ).href
          "
          target="_blank"
          >{{ item.assetName }}
        </a>
      </td>
    </template>
  </FlotoCrudContainer>
</template>

<script>
import { getVmDetailsApi } from '@modules/asset/asset-api'
export default {
  name: 'MemoryAllocation',
  props: {
    resourceId: { type: Number, required: true },
    moduleName: { type: String, required: true },
  },
  data() {
    return {
      tableColumns: [
        { name: `${this.$tc('vm_id')}`, key: 'assetName' },
        { name: `${this.$tc('vm_name')}`, key: 'assetDispalyName' },
        {
          name: `${this.$tc('limit')} ${this.$tc('in_mb')}`,
          key: 'memoryLimit',
        },
        {
          name: `${this.$tc('reservation')}  ${this.$tc('in_mb')}`,
          key: 'memoryReservation',
        },
        {
          name: `${this.$tc('shares')}`,
          key: 'memoryShares',
        },
        {
          name: `${this.$tc('shares_level')}`,
          key: 'memorySharesLevel',
        },
      ],
    }
  },
  methods: {
    getVmDetails(limit, offset) {
      return getVmDetailsApi(
        this.resourceId,
        limit,
        offset,
        this.moduleName === this.$constants.CMDB ? 'cmdb' : 'asset'
      )
    },
  },
}
</script>
